import { Locale } from "./utils";

export const JD_ID = 380;
export const GROUPON_ID = 391;
export const SUPERMARKET_ID = 263;

export const TIANDITU_KEY = "08e315f8bde36c434bb037d8512a28f2";
export const TIANDITU_VERSION = "4.0";
export const TIANDITU_ZOOM = 17;

const i18n = Locale.getInstance();
export const FILTER_STATUS = {
  ALL: { value: -1, name: i18n.t("article.all") },
  CLOSED: { value: 0, name: i18n.t("shows.status.invalid") },
  OPENED: { value: 1, name: i18n.t("shows.status.valid") },
};

export const FILTER_THEME_STATUS = {
  ALL: { value: -1, name: i18n.t("article.all") },
  WHEEL: { value: 0, name: i18n.t("lottery.wheel") },
  NINE: { value: 1, name: i18n.t("lottery.nine") },
  FRUIT: { value: 2, name: i18n.t("lottery.fruit") },
};
